import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["picker", "input", "value", "swatch"]

  connect() {
    this.#sync(this.inputTarget.value || this.pickerTarget.getAttribute("value") || "#000000")
  }

  change(event) {
    this.#sync(event.target.value)
  }

  selectSwatch(event) {
    event.preventDefault()
    const color = event.currentTarget.dataset.color
    this.pickerTarget.value = color
    this.#sync(color)
  }

  #sync(color) {
    this.inputTarget.value = color
    this.valueTarget.textContent = color
    const normalized = color.toLowerCase()
    this.swatchTargets.forEach(swatch => {
      const selected = swatch.dataset.color.toLowerCase() === normalized
      swatch.setAttribute("aria-pressed", selected ? "true" : "false")
      swatch.classList.toggle("ring-neutral-500", selected)
      swatch.classList.toggle("ring-transparent", !selected)
    })
  }
}
